export function estimateScreenResourceDemand({
  resolution,
  fps,
  contentHint,
  nativeHeight = 0,
}: {
  resolution: string;
  fps: string | number;
  contentHint: string;
  nativeHeight?: number;
}) {
  const resolvedHeight =
    resolution === "native" && nativeHeight > 0 ? nativeHeight : Number(resolution);
  const resolutionWeight =
    resolvedHeight > 0 && resolvedHeight <= 720
      ? 1
      : resolvedHeight <= 1080 && resolvedHeight > 0
        ? 2
        : resolvedHeight <= 1440 && resolvedHeight > 0
          ? 3
          : 4;
  const frameRate = Number(fps) || 30;
  const frameRateWeight = frameRate <= 15 ? 0 : frameRate <= 30 ? 1 : 3;
  const motionWeight = contentHint === "motion" && frameRate >= 30 ? 1 : 0;
  const score = resolutionWeight + frameRateWeight + motionWeight;

  if (score <= 2) return { level: 1, severity: "low" };
  if (score <= 4) return { level: 2, severity: "moderate" };
  if (score <= 6) return { level: 3, severity: "high" };
  return { level: 4, severity: "veryHigh" };
}
